export default Object.freeze({
  Pending: 1,
  Sending: 2,
  Delivered: 3,
  Failed: 4,
  DeadLetter: 5,
});
